import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AnalyticsLoaderService } from './analytics-loader-service';
import { AnalyticsTrackingService } from './analytics-tracking-service';

@Injectable({ providedIn: 'root' })
export class AnalyticsInitializerService {
  constructor(
    private analytics: AnalyticsTrackingService,
    private loader: AnalyticsLoaderService,
    private router: Router,
  ) {}

  async load(ga4MeasurementId: string): Promise<void> {
    await this.loader.load(ga4MeasurementId);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.analytics.pageView(e.urlAfterRedirects);
      });
  }
}
